import { IDictionary } from './dictionary';
export type { IDictionary };

export const NoColor = '#13a8a800';
